import React from 'react';

const MainSlider = () => {
  return (
    <section className="main-slider">
      <div className="main-slider__carousel owl-carousel owl-theme">
        <div className="item">
          <div className="main-slider__bg" style={{ backgroundImage: 'url(assets/images/18.jpg)' }}></div>
          <div className="main-slider__overly"></div>
          <div className="main-slider__shape-bg" style={{ backgroundImage: 'url(assets/images/shapes/main-slider-shape-bg.png)' }}></div>
          <div className="main-slider__shape-1">
            <img src="assets/images/shapes/main-slider-shape-1.png" alt="" className="float-bob-y" />
          </div>
          <div className="main-slider__shape-2">
            <img src="assets/images/shapes/main-slider-shape-2.png" alt="" className="float-bob-x" />
          </div>
          <div className="container">
            <div className="main-slider__content">
              <div className="main-slider__sub-title-box">
                <div className="main-slider__sub-title-shape"></div>
                <p className="main-slider__sub-title">Give Hope For Homeless </p>
                <div className="main-slider__sub-title-shape"></div>
              </div>
              <h2 className="main-slider__title">We Are non profit <br /> <span>charity</span> organization</h2>
              <div className="main-slider__btn-box">
                <div className="main-slider__btn">
                  <a href="/contact" className="thm-btn">
                    <span className="thm-btn-text">Donate Now</span>
                    <span className="thm-btn-icon-box"><i className="fas fa-arrow-right"></i></span>
                  </a>
                </div>
                <div className="main-slider__video-link">
                  <a href="https://www.youtube.com/watch?v=Get7rqXYrbQ" className="video-popup">
                    <div className="main-slider__video-icon">
                      <span className="fa fa-play"></span>
                      <i className="ripple"></i>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="item">
          <div className="main-slider__bg" style={{ backgroundImage: 'url(assets/images/20.jpg)' }}></div>
          <div className="main-slider__overly"></div>
          <div className="main-slider__shape-bg" style={{ backgroundImage: 'url(assets/images/shapes/main-slider-shape-bg.png)' }}></div>
          <div className="main-slider__shape-1">
            <img src="assets/images/shapes/main-slider-shape-1.png" alt="" className="float-bob-y" />
          </div>
          <div className="main-slider__shape-2">
            <img src="assets/images/shapes/main-slider-shape-2.png" alt="" className="float-bob-x" />
          </div>
          <div className="container">
            <div className="main-slider__content">
              <div className="main-slider__sub-title-box">
                <div className="main-slider__sub-title-shape"></div>
                <p className="main-slider__sub-title">We help companies</p>
                <div className="main-slider__sub-title-shape"></div>
              </div>
              <h2 className="main-slider__title">Together, we can make <br /> the <span>world better</span></h2>
              <div className="main-slider__btn-box">
                <div className="main-slider__btn">
                  <a href="/contact" className="thm-btn">
                    <span className="thm-btn-text">Donate Now</span>
                    <span className="thm-btn-icon-box"><i className="fas fa-arrow-right"></i></span>
                  </a>
                </div>
                <div className="main-slider__video-link">
                  <a href="https://www.youtube.com/watch?v=Get7rqXYrbQ" className="video-popup">
                    <div className="main-slider__video-icon">
                      <span className="fa fa-play"></span>
                      <i className="ripple"></i>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="item">
          <div className="main-slider__bg" style={{ backgroundImage: 'url(assets/images/9.webp)' }}></div>
          <div className="main-slider__overly"></div>
          <div className="main-slider__shape-bg" style={{ backgroundImage: 'url(assets/images/shapes/main-slider-shape-bg.png)' }}></div>
          <div className="main-slider__shape-1">
            <img src="assets/images/shapes/main-slider-shape-1.png" alt="" className="float-bob-y" />
          </div>
          <div className="main-slider__shape-2">
            <img src="assets/images/shapes/main-slider-shape-2.png" alt="" className="float-bob-x" />
          </div>
          <div className="container">
            <div className="main-slider__content">
              <div className="main-slider__sub-title-box">
                <div className="main-slider__sub-title-shape"></div>
                <p className="main-slider__sub-title">Give Hope For Homeless </p>
                <div className="main-slider__sub-title-shape"></div>
              </div>
              <h2 className="main-slider__title">They Need Your <br /> <span>Help</span> to Live</h2>
              <div className="main-slider__btn-box">
                <div className="main-slider__btn">
                  <a href="/contact" className="thm-btn">
                    <span className="thm-btn-text">Donate Now</span>
                    <span className="thm-btn-icon-box"><i className="fas fa-arrow-right"></i></span>
                  </a>
                </div>
                <div className="main-slider__video-link">
                  <a href="https://www.youtube.com/watch?v=Get7rqXYrbQ" className="video-popup">
                    <div className="main-slider__video-icon">
                      <span className="fa fa-play"></span>
                      <i className="ripple"></i>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MainSlider;
